import type { SwiperOptions } from 'swiper/types/swiper-options';

export const POSITION = 'Carousel';
export const LEFT_ARROW = 'Left arrow';
export const RIGHT_ARROW = 'Right arrow';

export const recommendedBaseCarouselAutoplay: SwiperOptions = {
  // NOTE: if you use autoplay, add the Autoplay plugin module from swiper/modules
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  loop: true,
  speed: 1000,
};

export const recommendedBaseCarouselPagination: object = {
  // NOTE: if you use pagination, add the Pagination plugin module from swiper/modules
  clickable: false,
  el: '.swiper-pagination', // Use a valid DOM element here
  enabled: true,
  type: 'bullets',
};
